const LoadingSpinner = require('loading-spinner').LoadingSpinner;

const deps = [require('ngreact').name];

const mod = angular.module('bench.ui.loadingSpinner', deps);

mod.directive('blLoadingSpinner', [
  'reactDirective',
  reactDirective => reactDirective(LoadingSpinner, [], {}, {}),
]);

module.exports = mod;
